<div [ngClass]="[styles.sceneRow, largeScenes ? styles.sceneRowLarge: '']">
	<span class="glyphicons chevron-left" [ngClass]="styles.sceneScrollLeft" (click)="scrollScenes(-1)"></span>

	<span class="glyphicons chevron-right" [ngClass]="styles.sceneScrollRight" (click)="scrollScenes(1)"></span>

	<ng-container *ngFor="let scene of shownScenes; index as i">
		<ng-template #ttTemplate>
			<div *ngFor="let user of sceneUsers[i]">
				{{ user }}
			</div>
		</ng-template>
		<img [src]="scene.imageUrl" (click)="select(scene.layout)" [tooltip]="ttTemplate" [isDisabled]="!sceneUsers[i].length" alt="" vbImageLoad/>
	</ng-container>
</div>
